import { COMPLEX } from 'utils/constants'
import { curry, type, equals } from 'ramda'

// isType :: String -> a -> Boolean
const isType = curry((typeToCheck, val) => type(val) === typeToCheck)

// :: a -> Boolean
const isObject = isType('Object')
const isNumber = (number) => isType('Number', number) && !equals(number, NaN)
const isString = isType('String')
const isRegExp = isType('RegExp')
const isBoolean = isType('Boolean')
const isNull = isType('Null')
const isArray = isType('Array')
const isUndefined = isType('Undefined')
const isFunction = isType('Function')
const isFalse = equals(false)
const isTrue = equals(true)

// https://stackoverflow.com/questions/30469261/checking-for-typeof-error-in-js
const isError = (error) => error && error.stack && error.message

// isLogicSet :: String -> Boolean
const isLogicSet = equals(COMPLEX)
const isInput = equals('input')
const isOutput = equals('output')

/**
 *
 * @param {String} string
 *
 * @example
 *
 *    toInt('10') //=> 10
 *    toInt('019') //=> 19
 */
// radix doesn't default to 10
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/parseInt
const toInt = (string) => parseInt(string, 10)

/**
 *
 * @param {Boolean} condition
 * @param  {...any} items
 *
 * @example
 *    const a = [
 *      ...insertIf(true, { a: 1, b: 2 }),
 *      { a: 1, b: 2, c: 3 },
 *    ] // => [{ a: 1, b: 2 }, { a: 1, b: 2, c: 3 }]
 *
 *    const b = [
 *      ...insertIf(false, { a: 1, b: 2 }),
 *      { a: 1, b: 2, c: 3 },
 *    ] // => [{ a: 1, b: 2, c: 3 }]
 */
const insertIf = (condition, ...items) => (condition ? items : [])

const set = (args) => new Set(args)

const isInt = (n) => n % 1 === 0

const toFixed = (n, dec) => n.toFixed(dec)

export {
  isObject,
  isNumber,
  isString,
  isRegExp,
  isBoolean,
  isNull,
  isArray,
  isUndefined,
  isError,
  isFunction,
  isLogicSet,
  isInput,
  isOutput,
  toInt,
  insertIf,
  set,
  isFalse,
  isTrue,
  isInt,
  toFixed,
}
